export default IconBrandFeedly => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-brand-feedly" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M7.833 12.278l4.445 -4.445" />
  <path d="M10.055 14.5l2.223 -2.222" />
  <path d="M12.278 16.722l.555 -.555" />
  <path d="M19.828 14.828a4 4 0 0 0 0 -5.656l-5 -5a4 4 0 0 0 -5.656 0l-5 5a4 4 0 0 0 0 5.656l6.171 6.172h3.314l6.171 -6.172z" />
</svg>`;